<ng-template #clientCompanyModal let-modal>
  <div class="modal-header" style="padding: 10px;">
    <h6 class="modal-title" id="modal-basic-title" style="margin-top: 0px;">Client Company Details</h6>
    <button type="button" class="close" (click)="modal.dismiss('close')">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body" style="font-size: 12px;">
    <section class="client-list-container">
      <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters" [pageSize]="5" [filtersComponent]="dataFilters" (onTableRowClick)="onTableRowClickEvent($event)">
        <app-data-filters #dataFilters>
          <app-data-filter-group>
            <app-data-filter-input [label]="'client-list.id.label' | translate" [(model)]="filters.id"
                                    [placeholder]="'client-list.id.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.firstName.label' | translate" [(model)]="filters.firstName"
                                    [placeholder]="'client-list.firstName.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.lastName.label' | translate" [(model)]="filters.lastName"
                                    [placeholder]="'client-list.lastName.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.email.label' | translate" [(model)]="filters.email"
                                    [placeholder]="'client-list.email.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.username.label' | translate" [(model)]="filters.username"
                                    [placeholder]="'client-list.username.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.company.label' | translate" [(model)]="filters.company"
                                    [placeholder]="'client-list.company.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.address.label' | translate" [(model)]="filters.address"
                                    [placeholder]="'client-list.address.placeholder' | translate"></app-data-filter-input>
          </app-data-filter-group>
        </app-data-filters>
      </app-data-table>
      </section>
    <hr />
    <app-data-tabset 
      [client]="client"
      [company]="company"
      [createNewClientEnv]="createNewClientEnv"
      (_onSelectedCompany)="getSelectedCompany($event)"></app-data-tabset>
  </div>
  <div class="modal-footer">
      <div class="btn-group btn-group-sm" role="group">
        <button type="button" class="btn btn-secondary" (click)="onResetButtonClickEvent()">Reset</button>
        <button type="button" class="btn btn-secondary" [disabled]="createNewClientEnv === false" (click)="updateClientClickEvent(true)">Create New</button>
        <button type="button" class="btn btn-secondary" [disabled]="createNewClientEnv" (click)="updateClientClickEvent(false)">Update</button>
        <!-- <button type="button" class="btn btn-secondary" [disabled]="createNewClientEnv" (click)="selectClientClickEvent()">Select</button> -->
      </div>
  </div>
</ng-template>

<ng-container *ngIf="searchIcon; else selectTemplate">
  <button class="btn btn-sm btn-primary" (click)="open(clientCompanyModal)"><i class="fa fa-users"></i></button>
</ng-container>
<ng-template #selectTemplate>
  
</ng-template>

<!-- <button class="btn btn-sm btn-primary" style="margin:0px;" (click)="open(clientCompanyModal)">Details</button> -->


<ng-template #idColumn let-id="id">
  {{id}}
</ng-template>

<ng-template #firstNameColumn let-firstName="firstName">
  {{firstName}}
</ng-template>

<ng-template #lastNameColumn let-lastName="lastName">
  {{lastName}}
</ng-template>

<ng-template #emailColumn let-email="firstEmail">
  {{email}}
</ng-template>

<ng-template #usernameColumn let-username="username">
  {{username}}
</ng-template>

<ng-template #companyColumn let-company="company">
  <span *ngIf="company"> {{company.name}} </span>
</ng-template>

<ng-template #addressColumn let-company="company">
  <span *ngIf="company.address"> {{company.address}} </span>
</ng-template>

<ng-template #actionsColumn let-id="id">
  {{id}}
</ng-template>